const ATALogo = "https://s3.eu-west-1.amazonaws.com/aryabhattadev.quloi.com/build/logo_ata_email.png"

export const ContainerMasterMailBody = (shipment) => {
    return`<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 2300px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
    <div style="width: 100%; background-color: transparent; line-height: inherit;">
      <div>
        <span>Dear Team,</span>
        </br>
        <p>Please find below container details.
        </br>
        <table style="border: 1px solid black;border-collapse: collapse; overflow-x: scroll; max-width: 2300px;">
            <tr>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Module</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Factory In</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Factory Out</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Invoice</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Tractor Qty</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Agg Qty</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Agg Part</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">RFID Seal No.</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Container No.</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Seal No.</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">LR No.</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Vehicle No.</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Carrier</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Clearence</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Dest Country</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Dest Port</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Final Dest</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Product</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Booking No.</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Transporter</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Pickup Location</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">SAP Code</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Container Type</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Driver No.</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Remarks</th>
            </tr>
            ${shipment.map((item) => {
              var factoryIn = item.Gate_In_Date !== "" ? item.Gate_In_Date:""
              var factoryOut = item.Gate_Out_Date !== "" ? item.Gate_Out_Date:""
              var invData = item.invoice ? item.invoice : ""
              var tractorQty = item.T_qty ? item.T_qty : ""
              var aggQty = item.A_qty ? item.A_qty : ""
              var aggPart = item.A_Part ? item.A_Part : ""
              var RFIDSeal = item.RFID_Seal_No ? item.RFID_Seal_No : ""
              var containerNo = item.Container_Number ? item.Container_Number : ""
              var sealNo = item.Seal_No ? item.Seal_No : ""
              var LRNo = item.LR_NO ? item.LR_NO : ""
              var vehicle = item.Vehicle_No ? item.Vehicle_No : ""
              var carrierData = item.Carrier ? item.Carrier : ""
              var clearenceData = item.Clearance ? item.Clearance : ""
              var destCountry = item.Dest_Country ? item.Dest_Country : ""
              var destPort = item.Dest_Port ? item.Dest_Port : ""
              var finalDest = item.final_destination ? item.final_destination : ""
              var product = item.Product ? item.Product : ""
              var bookingNo = item.Booking_Number ? item.Booking_Number : ""
              var transporterData = item.Transporter ? item.Transporter : ""
              var pickupLoc = item.pick_up_location ? item.pick_up_location : ""
              var SAPCode = item.SAP_code ? item.SAP_code : ""
              var containerTypeData = item.Container_Type ? item.Container_Type : ""
              var DriverNo = item.Driver_No ? item.Driver_No : ""
              var Remark = item.Remarks ? item.Remarks : ""
              return `
                  <tr>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${item.DataOf}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${factoryIn}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${factoryOut}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                  ${invData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                  ${tractorQty}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                  ${aggQty}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${aggPart}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${RFIDSeal}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                  ${containerNo}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${sealNo}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${LRNo}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${vehicle}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${carrierData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${clearenceData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                  ${destCountry}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                  ${destPort}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                  ${finalDest}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${product}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${bookingNo}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                  ${transporterData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${pickupLoc}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${SAPCode}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${containerTypeData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${DriverNo}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 2300px; text-align: center; font-size:14px">
                    ${Remark}
                  </td>
                  </tr>`;
            }).join(" ")}
        </table>
      </div>
      <div style="margin-top: 30px;margin-bottom: -30px;">
        Thanks and Regards,
      </div>
      <img src=${ATALogo} alt="ATA Logo" />
    </div>
  </div>`
}